<template>
  <div class="app-mon-fx2">
    <section class="section topbar">
      <div class="header-con">
        <a
          href="javascript:;"
          :class="{'header-item': true, 'expansionPack': true, 'active': !isExpansion}"
          @click="changePage(false)"
        ><h3>升级</h3></a>
        <a
          href="javascript:;"
          :class="{'header-item': true, 'expansionPack': true, 'active': isExpansion}"
          @click="changePage(true)"
        ><h3>扩展包</h3></a>
      </div>
      <div
        class="header-con backTo"
        @click="closeWindow"
      >
        <h3>关闭</h3>
      </div>
    </section>
    <ModalBuy v-show="showModalBuy" />
    <!-- <section class="section promobar" style="display:none;">
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="promo-con promo-desc1">
              <h3 />
            </div>
            <div class="promo-con promo-desc2">
              <h3 />
            </div>
            <div class="promo-con count-down">
              <h3 />
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <section class="section main-gallery">
      <div class="inner">
        <div class="gallery">
          <div class="gallery-main-content">
            <div
              class="gallery-item"
              aria-hidden="true"
            >
              <figure>
                <img :src="meta.quote_image">
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section fx2-upgrade">
      <template v-if="!isExpansion">
        <h3>BIAS FX 2 升級</h3>
        <div class="notes">
          <span>* 适用于 PC 和 MAC 系统</span>
          <span>* 提供插件和独立运行版本</span>
        </div>
      </template>
      <template v-else>
        <h3>扩展包</h3>
        <div class="notes">
          <span>* 需要搭配 BIAS FX 1/2</span>
        </div>
      </template>
    </section>
    <section class="section product-card">
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <ul class="list">
                <li
                  v-for="buyOption in getBuyOptions()"
                  :key="buyOption.sku"
                  :class="{item: true, using: isUsing(buyOption.sku), active: isUsing(buyOption.sku)}"
                >
                  <template v-if="getFreeTrialExpireDate(buyOption.sku)">
                    <div class="free-trial-ribbon">
                      Trial ends {{ getFreeTrialExpireDate(buyOption.sku) }}
                    </div>
                  </template>
                  <h2 class="option">
                    {{ skuToName(buyOption.sku) }}
                  </h2>
                  <p class="desc">
                    {{ buyOption.description }}
                  </p>
                  <div
                    v-for="section in getSkuFeatureSections(buyOption.sku)"
                    :key="section.title"
                    class="sku-features-section"
                  >
                    <template v-if="section.title">
                      <h4>{{ section.title }}</h4>
                    </template>
                    <template v-if="section.footNote">
                      <div
                        v-for="footNote in section.items"
                        :key="footNote"
                        class="foot-note"
                      >
                        {{ footNote }}
                      </div>
                    </template>
                    <template v-else>
                      <ul>
                        <li
                          v-for="item in section.items"
                          :key="item"
                        >
                          {{ item }}
                        </li>
                      </ul>
                    </template>
                  </div>
                  <div
                    v-if="isUsing(buyOption.sku)"
                    class="using-grid"
                  >
                    <hr>
                    <div class="btn">
                      已购买
                    </div>
                  </div>
                  <div
                    v-else
                    class="price-btn-grid"
                  >
                    <div class="price-grid">
                      <template v-if="specialOffer(buyOption.sku)">
                        <span class="special-offer">特惠价&nbsp;</span>
                        <div class="price price--withoutTax">
                          ${{ actualPrice(buyOption.sku) }}
                        </div>
                        <div class="price price--rrp">
                          ${{ originalPrice(buyOption.sku) }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="price price--withoutTax">
                          ${{ actualPrice(buyOption.sku) }}
                        </div>
                      </template>
                    </div>
                    <div class="rmb-price">
                      人民币参考价 <span class="price-tag">¥{{ rmbRefPrice(buyOption.sku) }}</span>
                    </div>
                    <hr>
                    <form class="btn-grid">
                      <input
                        v-if="isLoginValid"
                        type="button"
                        :value="getCTAText(buyOption.sku)"
                        class="btn form-action-addToCart"
                        @click="showBuyModal({ sku: buyOption.sku, price: 99, versionText: skuToName(buyOption.sku), name: isExpansion ? null : 'BIAS FX 2' })"
                      >
                      <input
                        v-else
                        type="button"
                        :value="getCTAText(buyOption.sku)"
                        class="btn form-action-addToCart"
                        @click="goLogin()"
                      >
                    </form>
                  </div>
                </li>
                <li
                  v-for="index in getItemPaddingCount()"
                  :key="index"
                  class="item flex-padding"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="section"
      style="display:none;"
    >
      <div class="grid-container">
        <div class="pricing-note">
          <p>*pricing tags are updated for the promotions</p>
        </div>
        <div class="line" />
      </div>
    </section>
    <section
      class="section feature"
      style="display:none;"
    >
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <h2 class="title">
                FEATURE
              </h2>
            </div>
            <div class="column-content feature-list-grid">
              <ul data-auto-height>
                <li class="grid-half-column left product">
                  <h3 class="option-title pro">
                    <span>BIAS FX 2</span>
                    <br>
                    <span class="option">Professional</span>
                  </h3>
                  <ul>
                    <li
                      class="card-text"
                    >
                      Unleash more amps and effect models to discover the professional tonal possibilities.
                    </li>
                    <li>32 guitar amps</li>
                    <li
                      class="card-title"
                    >
                      64 guitar effects & 10 advanced Studio Rack processor units
                    </li>
                    <li>Dual signal path</li>
                    <li>Full MIDI and automation support</li>
                  </ul>
                </li>
                <li class="grid-half-column right product">
                  <h3 class="option-title std">
                    <span>BIAS FX 2</span>
                    <br>
                    <span class="option">Standard</span>
                  </h3>
                  <ul>
                    <li
                      class="card-text"
                    >
                      Flexible guitar and bass amp-and-effects processing station.
                    </li>
                    <li>12 guitar amps</li>
                    <li class="card-title">
                      30 guitar effects
                    </li>
                    <li>Dual signal path</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <login-window
      v-if="showLoginWindow"
      :token="token"
      @close="goLogin"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import store from '@/store'
import ModalBuy from '@/components/modal-buy'
import LoginWindow from '@/components/login-window'
import jwtDecode from 'jwt-decode'
import urls from '@/urls'

const SKU_FEATURES = {
  'L2103': [
    {
      title: '新特性：',
      items: [
        '总计30款新音箱',
        '总计43款新效果器',
        '总计70个新的厂家预设',
        '吉他匹配功能 – 基本包（4 种型号）'
      ]
    },
    {
      items: [
        '新的循环录音机功能',
        '极大改进的新DSP引擎',
        '在音色云上创建和下载数以千计的音色预设',
        '操作方便的新用户界面',
        '带有多个信号分离器的双信号线路',
        '数以百计的改进'
      ]
    }
  ],
  'L2102': [
    {

      title: '除了标准版的所有特性之外还包括：',
      items: [
        '总计 60 款新音箱',
        '总计 115 款新效果器',
        '总计 130 个新的厂家预设',
        '吉他匹配功能 – 专业包（8 种型号）',
        '总计 14 款 HD 机架效果器'
      ]
    },
    {
      items: [
        '新的 MIDI/自动化功能',
        '专门的 IR 加载器',
        '全新的定制艺术家预置音色'
      ]
    }
  ],
  'L2101': [
    {
      title: '除了专业版的所有特性之外还包括：',
      items: [
        '总计 100 款新音箱',
        '总计 122 款新效果器',
        '总计 210 个新的厂家预设',
        '吉他匹配功能 – 精英包（20 种型号）',
        '总计 18 款 HD 机架效果器'
      ]
    },
    {
      items: [
        '新的法兹建模效果器',
        '新的时间建模效果器',
        '新的和声建模效果器'
        // '附赠 - BIAS Pedal 软件（包括：失真、延时和调制效果器) '
      ]
    }
  ],
  'L1111': [ // celestion modern vintage
    {
      title: '包括：',
      items: [
        'Celestion G12H-75 Creamback',
        'Celestion G12M-65 Creamback',
        'Celestion Neo Creamback',
        'Celestion G12H-150 Redback',
        'Celestion A-Type'
      ]
    },
    {
      title: '对应至三种箱体样式：',
      items: [
        '1x12',
        '2x12',
        '4x12'
      ]
    },
    {
      footNote: true,
      items: [
        '*总计 15 款箱体',
        '*需要搭配 BIAS FX 1/2 或 BIAS AMP 1/2'
      ]
    }
  ],
  'L1114': [ // celestion classic
    {
      title: '包括：',
      items: [
        'Celestion Vintage 30',
        'Celestion Blue',
        'Celestion G12H Anniversary',
        'Celestion G12-65',
        'Celestion G12M Greenback'
      ]
    },
    {
      title: '对应至三种箱体样式：',
      items: [
        '1x12',
        '2x12',
        '4x12'
      ]
    },
    {
      footNote: true,
      items: [
        '*总计 15 款箱体',
        '*需要搭配 BIAS FX 1/2 或 BIAS AMP 1/2'
      ]
    }
  ],
  'L2011': [ // Metal pack
    {
      title: '包括的单块：',
      items: [
        'Merrow Gate (Gate)',
        'Merrow Drive (Drive)',
        'Loomis OD (Drive)',
        'Loomis PQ (EQ)',
        'Ola Chorus (Mod)',
        'Ola Delay (Delay)'
      ]
    },
    {
      title: '包括的音箱：',
      items: [
        'Loomis Metal (HI Gain)',
        'Merrow Fire (HI Gain)',
        'Merrow 5153 (HI Gain)',
        'Ola War (HI Gain)',
        'Loomis 120 (Acoustic)',
        'Ola Peace (Acoustic)'
      ]
    }
  ],
  'L2012': [ // Bass pack
    {
      title: '包括的单块：',
      items: [
        'Bass Compressor (Comp)',
        'Bass DI Driver (Drive)',
        'Bass Deluxe Drive (Drive)',
        'Bass EQ (EQ)',
        'Bass Chorus (Mod)',
        'Bass Octave (Pitch/Filter)',
        'Bass Envelope (Pitch/Filter)'
      ]
    }
  ],
  'L2013': [ // Acoustic pack
    {
      title: '包括的单块：',
      items: [
        'Acoustic EQ (EQ)',
        'Acoustic Chorus (Mod)',
        'Acoustic Reverb (Reverb)',
        'Acoustic Image (EQ)',
        'Acoustic Simulator (EQ)'
      ]
    },
    {
      title: '包括的前置放大器：',
      items: ['Acoustic Preamp (Drive)']
    }
  ]
}

const FREE_TRIAL_LICENSE_TO_SKU_MAP = {
  'ELITE': 'L2101',
  'PRO': 'L2102',
  'STD': 'L2103'
}

const FX2_CTA_TEXT = {
  PURCHASED: '已购买',
  REQUIRE_FX: '需要搭配 BIAS FX 1/2',
  PURCHASE: '购买',
  UPGRADE: '升级',
  PURCHASE_SPECIAL_OFFER: '以特惠价购买',
  UPGRADE_SPECIAL_OFFER: '以特惠价升级'
}

export default {
  store,
  components: {
    ModalBuy,
    LoginWindow
  },
  data () {
    return {
      meta: {},
      showModal: false,
      isExpansion: false,
      skuPrices: {},
      productsData: [],
      freeTrialInfo: {
        freeTrialSku: null,
        expireDateString: null
      },
      showLoginWindow: false
    }
  },
  computed: {
    ...mapState('ModalBuy', {
      showModalBuy: 'show'
    }),
    ...mapGetters('Auth', {
      isLoginValid: 'isLoginValid',
      token: 'token'
    }),
    ...mapGetters('Software', {
      isOwnedSku: 'isOwnedSku',
      isPackActive: 'isPackActive',
      getActiveLicenseTier: 'getActiveLicenseTier'
    })
  },
  async mounted () {
    const pgToken = this.hasLoginToken()
    if (pgToken) {
      this.setLoginToken(pgToken)
      if (this.isLoginValid) {
        await this.getOwnedLicense({ token: this.token, product: 'fx2' })
      }
    }
    await this.fetchIasMeta()
    await this.fetchProductPrice()
    await this.fetchFreeTrialInfo()
    if (this.isUsing('L2101') && !this.isExpansion) { // using elite
      this.changePage(true)
    }
    console.log('mounted')
  },
  methods: {
    ...mapActions('ModalBuy', {
      showBuyModal: 'showBuyModal'
    }),
    closeWindow () {
      if (window.self !== window.top) {
        window.parent.postMessage({ action: 'InAppStore.CloseWebView' }, '*')
      } else {
        window.history.back()
      }
    },
    isUsing (sku) {
      if (this.isExpansion) {
        return this.isExpansion && this.isPackActive(sku)
      } else {
        return this.isOwnedSku(sku)
      }
    },
    hasLoginToken () {
      let qs
      if (this.$route.query['app_user_token']) {
        qs = this.$route.query['app_user_token']
      } else if (this.$route.query['login']) {
        qs = jwtDecode(this.$route.query['login'].split('/')[3])['redirect_to'].split('=')[1]
      }
      return qs
    },
    setLoginToken (token) {
      const decoded = jwtDecode(token)
      this.storeLogin({
        token,
        info: decoded
      })
    },
    async changePage (isExpansion) {
      this.isExpansion = isExpansion
      await this.fetchIasMeta()
    },
    getBuyOptions () {
      const PRODUCT_DISPLAY_ORDER = {
        L2011: 0, // Metal
        L2012: 1, // Bass
        L2013: 2, // Acoustic
        L1114: 3, // Celestion Classic
        L1111: 4, // Celestion Modern Vintage
        L2103: 0, // FX2 std
        L2102: 1, // FX2 pro
        L2101: 2 // FX2 elite
      }
      if (!this.meta.buy_option) return []
      return this.meta.buy_option.slice().sort((product1, product2) => PRODUCT_DISPLAY_ORDER[product1.sku] - PRODUCT_DISPLAY_ORDER[product2.sku])
    },
    skuToName (sku) {
      return {
        L2103: '标准版',
        L2102: '专业版',
        L2101: '精英版',
        L2011: '金属扩展包',
        L2012: '贝斯扩展包',
        L2013: '原声扩展包',
        L1111: 'Celestion 现代复古包',
        L1114: 'Celestion 经典扩展包'
      }[sku]
    },
    getCTAText (sku) {
      if (!this.isLoginValid) { return '请先登录' }
      if (this.isUsing(sku)) { return FX2_CTA_TEXT.PURCHASED }
      if (this.isExpansion) {
        if (this.specialOffer(sku)) {
          return FX2_CTA_TEXT.PURCHASE_SPECIAL_OFFER
        } else {
          return FX2_CTA_TEXT.PURCHASE
        }
      } else {
        if (this.specialOffer(sku)) {
          return FX2_CTA_TEXT.UPGRADE_SPECIAL_OFFER
        } else {
          return FX2_CTA_TEXT.UPGRADE
        }
      }
    },
    getItemPaddingCount () {
      if (this.meta.buy_option) {
        const ITEMS_PER_ROW = 3
        const flexPaddings = this.meta.buy_option.length % ITEMS_PER_ROW === 0 ? 0 : (ITEMS_PER_ROW - (this.meta.buy_option.length % ITEMS_PER_ROW))
        return flexPaddings
      }
      return 0
    },
    async fetchIasMeta () {
      const result = await axios.get(`${urls.NEW_API_URL}/v3/public_announcement/ias`, {
        params: {
          product: 'fx2',
          expansion: this.isExpansion,
          locale: 'zh-cn'
        }
      })
      // if (!this.isExpansion) { result['data'].buy_option.reverse() }
      this.meta = result['data']
    },
    async fetchProductPrice () {
      const result = await axios({
        method: 'GET',
        url: `${urls.NEW_API_URL}/china/sales`
      })

      this.productsData = result.data
      console.log(this.productsData)
    },
    async fetchFreeTrialInfo () {
      const HOST = urls.NEW_API_URL
      const url = `${HOST}/v3/pa_free_trial?pname=fx2`
      try {
        const result = await axios({
          method: 'GET',
          headers: {
            'Authorization': `JWT ${this.token}`,
            'Content-Type': 'application/json'
          },
          url
        })
        if (Array.isArray(result.data)) {
          const info = result.data[0]
          if (!info) return
          const freeTrialSku = FREE_TRIAL_LICENSE_TO_SKU_MAP[info.license_tier]
          const expireDateString = (new Date(info.expire)).toLocaleDateString('en-US')

          this.freeTrialInfo = { freeTrialSku, expireDateString }
        }
      } catch (e) {
        console.log('error fetching free trial info', e)
      }
    },
    getFreeTrialExpireDate (sku) {
      if (this.freeTrialInfo.freeTrialSku && this.freeTrialInfo.freeTrialSku === sku) {
        return this.freeTrialInfo.expireDateString
      } else {
        return null
      }
    },
    getSkuFeatureSections (sku) {
      return SKU_FEATURES[sku]
    },
    specialOffer (sku) {
      let result
      if (this.actualPrice(sku) && this.originalPrice(sku)) {
        result = this.originalPrice(sku) > this.actualPrice(sku)
      } else {
        result = false
      }
      return result
    },
    originalPrice (sku) {
      if (!this.productsData || this.productsData.length === 0) return 0
      return this.productsData.find(product => product.product.sku === sku).price
    },
    actualPrice (sku) {
      if (!this.productsData || this.productsData.length === 0) return 0
      return this.productsData.find(product => product.product.sku === sku).discount || this.originalPrice(sku)
    },
    rmbRefPrice (sku) {
      if (!this.productsData || this.productsData.length === 0) return 0
      return this.productsData.find(product => product.product.sku === sku).cn_price
    },
    goLogin () {
      if (window.self !== window.top) {
        window.parent.postMessage(
          { action: 'FROM_TONECLOUD_TO_FX2.OPEN_LOGIN_MODAL' },
          '*'
        )
        window.parent.postMessage({ action: 'InAppStore.CloseWebView' }, '*')
      } else {
        const body = document.body
        this.showLoginWindow = !this.showLoginWindow
        this.showLoginWindow ? body.classList.add('modal-open') : body.classList.remove('modal-open')
      }
    },
    ...mapMutations('Auth', {
      storeLogin: 'LOGIN'
    }),
    ...mapActions('Software', {
      getOwnedLicense: 'getOwnedLicense'
    })
  }
}
</script>
<style lang="scss">
@import "../styles/base/breakpoint.scss";
@import "../styles/base/productGridGuideline.scss";
@import "../styles/base/gradient.scss";
// Sound Section

@keyframes loadingKeyFrames {
  0% {
    background-position: -350% 0;
  }
  100% {
    background-position: 500% 0;
  }
}

@mixin loading {
  &::before {
    content: "";
    border-radius: 2px;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: rgba(255, 255, 255, 0.2);
  }
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    left: 0;
    background: linear-gradient(
      90deg,
      rgba(lightgrey, 0) 0,
      rgba(lightgrey, 0.4) 25%,
      rgba(lightgrey, 0.8) 50%,
      rgba(lightgrey, 0.4) 75%,
      rgba(lightgrey, 0) 100%
    );
    background-size: 80% 100%;
    background-position: -350% 0;
    background-repeat: no-repeat;
    -webkit-animation: loadingKeyFrames 2s infinite;
    animation: loadingKeyFrames 2s infinite;
  }
}

$topbar-font-size: 1rem;
$topbar-text-color-normal: rgb(208, 208, 208);
$container-padding: 0 1.45em;
$warm-grey: #757575;

.app-mon-fx2{
  * {
    box-sizing: border-box;
  }
  padding-top: 42px;
  margin: auto;
  background:#1D1D1D;
  background-image: url('../assets/app-mon/bg-repeat@2x.png');
  background-repeat: repeat;
  .section{
    .grid-container, .grid-half-container, .section-content, .line{
      padding: $container-padding;
      margin:auto;
    }
    .section-content {
      text-align: center;
      background: #141414;
      h2 {
        margin-top: 3rem;
      }
      p {
        font-size: 1.5rem;
        margin-bottom: 0;
      }
    }
    .origin {
      color: color_guide_line("origin");
      &-border {
        border-color: color_guide_line("origin");
      }
    }
    .new-seal{
      span{
        border: 2px solid;
        border-radius: 3px;
        padding: 0.3rem 0.7rem;
        font-weight: bold;
        font-size: 1.2rem;
      }
      margin-bottom: 1rem;
    }
    .title{
      font-size: 3rem;
    }
    .subtitle{
      margin-bottom:1.5rem;
      font-size:1rem;
    }
    .text {
      color: color_guide_line("white");
      margin-bottom: 5rem;
    }
    h2 {
      font-size: 3rem;
    }
    p {
      color: color_guide_line("white");
    }
    .grid-container {
      width: 100%;
      &:after {
        content: "";
        display: block;
        clear: both;
      }
      .grid-one-third-column,
      .grid-two-third-column {
        width: 31%;
        .grid-half-item {
          width: 100%;
          .inner {
            // background:color_guide_line('black-five');
            .column-content {
              width: 70%;
              margin: auto;
            }
          }
        }
        &.left {
          float: left;
          .line {
            @include linear_gradient_line("right");
            width: 100%;
            height: 2px;
          }
        }
        &.right {
          float: left;
          margin-left: 3%;
          .line {
            @include linear_gradient_line("left");
            width: 100%;
            height: 2px;
          }
        }
      }
      .grid-two-third-column {
        width: 66%;
      }
      .pricing-note {
        text-align: right;
        p {
          margin-bottom: 0;
          font-size: 1rem;
          color: #f0f0f0;
        }
      }
      .line {
        // width: 100%;
        height: 1px;
        border-bottom: 1px solid #707070;
      }
    }
    .grid-half-container {
      max-width: 1440px;
      &:after {
        content: "";
        display: block;
        clear: both;
      }
    }
    .grid-half-item {
      box-sizing: border-box;
      width: 50%;
      padding-bottom: 2rem;
      @media (min-width: 552px) {
      }
      @include breakpoint("medium") {
      }
      &.grid-full-width {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
      }
      .inner {
        padding: 3rem 0;
      }
    }
    .gallery{
      height: 100%;
      .gallery-main-content{
        height: 100%;
        .gallery-item{
          height: 100%;
          position: relative;
        }
      }
    }
    figure {
      text-align: center;
      // box-shadow: #000 0 4vw 6vw -2.5vw;
      // background: transparent;
      margin: 0;
      height: 100%;
      width: 100%;
      overflow: hidden;
      background-size: cover;
      background-position: center;
      img{
        border-radius: 5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        @include breakpoint("medium"){
          width:100%;
        }
      }
    }
    figcaption {
      position: absolute;
      right: 0;
      top: 25%;
      bottom: 0;
      margin: auto;
      width: 50%;
      height: 60%;
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.3);
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      padding: 0 0.5rem;
      p {
        text-align: right;
        margin-bottom:0rem;
        font-family: 'Noto Sans', 'PingFang TC';
        font-weight: 400;
        width: 100%;
        font-size: 1.1rem;
        &.artist {
          margin-bottom: 0;
        }
      }
      .artist-quote-grid {
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        margin-bottom: 0.8rem;
        &::before {
          float: left;
          width: 5px;
          content: "";
          height: 40px;
          width: 1%;
        }
        &::after {
          float: right;
          content: "...";
          width: 1%;
          height: 20px;
          line-height: 20px;
          /* 为三个省略号的宽度 */
          width: 3em;
          /* 使盒子不占位置 */
          margin-left: -3em;
          /* 移动省略号位置 */
          position: relative;
          left: 100%;
          top: -20px;
          padding-right: 5px;
        }
        .artist-quote {
          float: right;
          margin-left: -5px;
          width: 99%;
          // word-break: break-all;
          text-align: justify;
        }
      }
    }
    .column-content{
      width: 100%;
      .title {
        font-size: 1.8rem;
      }
      .list{
        padding: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        flex-wrap: wrap;
        list-style-type:none;
        margin-left:0;
        margin-bottom:0;
        font-size: 0;
        .item{
          display: flex;
          position: relative;
          flex-direction: column;
          justify-content: flex-start;
          width: 263px;
          min-height: 350px;
          border-radius: 1px;
          border: solid 1px rgb(68, 68, 68);
          background-color: rgba(67, 67, 67, 0.2);
          text-align: left;
          color:#fff;
          vertical-align: top;
          padding:14.5px 16.5px 10px;
          margin-top: 25px;
          &.flex-padding{
            border: none;
            background: none;
          }
          .free-trial-ribbon{
            height: 35px;
            padding-top: 5px;
            width: 176px;
            background-size: cover;
            background-repeat: no-repeat;
            color: white;
            font-style: italic;
            font-family: 'Noto Sans', 'PingFang TC';
            letter-spacing: 0.21px;
            font-weight: bold;
            font-size: 12px;
            position: absolute;
            text-align: center;
            left: 50%;
            top: -17px;
            transform: translateX(-50%);
            background-image: url('../assets/app-mon/free-trial-ribbon@2x.png');
          }
          .category, .promo-slogan{
            margin-top:0;
            margin-bottom:0.17rem;
            font-size: 1.8rem;
            font-weight: 700;
            font-family: 'Noto Sans', 'PingFang TC';
          }
          .promo-slogan {
            color: #ffaa2f;
            padding-top: 0.85rem;
            margin-top: 0rem;
            margin-bottom: 0.01rem;
            visibility: hidden;
            + .category {
              margin-top: 0rem;
            }
          }
          .option{
            margin: 0;
            margin-bottom:0.17rem;
            font-size: 1.214rem;
            font-weight: 700;
            font-family: 'Noto Sans', 'PingFang TC';
            letter-spacing: 0.3px;
            color: rgb(255, 181, 55);
          }
          .desc{
            font-family: 'Noto Sans', 'PingFang TC';
            font-size: 12px;
            height: 54px;
            font-weight: 400;
            letter-spacing: 0.55px;
            position: relative;
            margin: 0;
            margin-bottom: 23px;
            color: rgb(208,208,208);
          }
          .sku-features-section{
            margin-bottom: 10px;
            h4{
              -webkit-text-size-adjust: none;
              margin: 0;
              padding: 0;
              font-size: 12px;
              font-family: 'Noto Sans', 'PingFang TC';
              font-stretch: condensed;
              letter-spacing: 0.3px;
              font-weight: bold;
              color: rgb(255, 181, 55);
            }
            ul{
              list-style-type: disc;
              margin-left: 20px;
              padding: 0;
            }
            li{
              -webkit-text-size-adjust: none;
              margin: 0;
              padding: 0;
              line-height: normal;
              font-size: 12px;
              letter-spacing: 0.55px;
              font-family: 'Noto Sans', 'PingFang TC';
              font-weight: 400;
              letter-spacing: 0.25px;
              color: rgb(208, 208, 208);
            }
            .foot-note{
              font-size: 12px;
              line-height: 13px;
              font-family: 'Noto Sans', 'PingFang TC';
              font-weight: 500;
              letter-spacing: 0.25px;
              color: $warm-grey;
            }
          }
          .price-btn-grid{
            margin-top: auto;
            font-family: 'Noto Sans', 'PingFang TC';
            .price-grid{
              position: relative;
              text-align: right;
              font-size: 0;
              vertical-align: bottom;
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
              .special-offer{
                font-size: 10px;
                color: rgb(255, 181, 55);
                font-weight: 400;
              }
              .price.price--withoutTax{
                line-height: 19px;
              }
              .price, .price--rrp{
                text-align: right;
                display: inline-block;
              }
              .price{
                margin-left: 2px;
                font-size: 17px;
                font-weight: bold;
                color: rgb(255, 181, 55);
              }
              .price--rrp{
                margin-left: 3px;
                font-size: 12px;
                color:#777777;
                text-decoration: line-through;
                font-weight: 400;
              }
            }
            .rmb-price{
              letter-spacing: 0.21px;
              height: 18px;
              font-size: 12px;
              width: 100%;
              text-align: right;
              color: $warm-grey;
              .price-tag{
                color: rgb(208,208,208);
              }
            }
            .btn-grid {
              width: 100%;
              text-align: center;
              .btn{
                cursor: pointer;
                margin:auto;
                width: 100%;
                height: 30px;
                border-radius: 1px;
                color:#1a1a1a;
                font-weight: bold;
                font-size: 13px;
                font-family: 'Noto Sans', 'PingFang TC';
                border:1px solid transparent;
                background-color:rgb(255, 181, 55);
                &:focus{
                  outline: none;
                }
              }
            }
          }
          .using-grid{
            margin-top: auto;
            display: none;
            width: 100%;
            text-align: center;
            .btn{
              margin:auto;
              width: 100%;
              height: 30px;
              line-height: 27px;
              border-radius: 1px;
              color: rgb(146,146,146);
              font-weight: bold;
              font-size: 13px;
              font-family: 'Noto Sans', 'PingFang TC';
              border:1px solid transparent;
              background-color: rgb(68, 68, 68);
              &:focus{
                outline: none;
              }
            }
          }
          .using-grid, .price-btn-grid {
            hr {
              margin: 0;
              margin-bottom: 10px;
              border-color: rgba(255,255,255, 0.15);
            }
          }
          &.promo{
            .promo-slogan{
              visibility: visible;
            }
            .price-btn-grid {
              .price-grid {
                .price--rrp {
                  display: inline-block;
                }
              }
            }
          }
          &.active{
            .promo-slogan{
              visibility: hidden;
            }
            .category,
            .option,
            .desc,
            .using-grid > p {
              color: #777777;
            }
            .price-btn-grid {
              display: none;
            }
            .using-grid {
              display: block;
            }
            .option{
              color: rgb(208, 208, 208);
            }
            .desc{
              color: $warm-grey;
            }
            .sku-features-section{
              h4{
                color: rgb(208,208,208);
              }
              li{
                color: $warm-grey;
              }
            }
          }
          &.loading {
            background: #777777;
            .category,
            .option,
            .desc,
            .btn-grid,
            .price-grid > .price {
              position: relative;
              @include loading();
            }
            .promo-slogan{
              height:34px;
            }
            .category {
              height: 16px;
              position: relative;
              &::before,
              &::after {
                height: 50%;
              }
            }
            .option {
              height: 26px;
              margin-bottom: 1.65rem;
              &::before,
              &::after {
                height: 80%;
              }
            }
            .desc {
              height: 54px;
              &::before,
              &::after {
                height: 90%;
              }
            }
            .price-grid {
              .price {
                height: 52px;
                &::before,
                &::after {
                  height: 60%;
                }
              }
            }
            .btn-grid {
              width: 138px;
              height: 37px;
              margin: auto;
              &::before,
              &::after {
                height: 90%;
                left:0;
                right:0;
                margin:auto;
              }
              .btn{
                border-color:transparent;
                background:transparent;
              }
            }
          }
        }
      }
    }
    &.topbar{
      background-image: url('../assets/app-mon/topbar-bg@2x.png');
      position: fixed;
      top: 0;
      left: 0;
      height: 42px;
      z-index: 10;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color:#212121;
      box-sizing: border-box;
      padding: 0 1.45rem;
      .header-con{
        text-align: center;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
        padding-top: 3px;
        &.backTo{
          justify-content: flex-end;
          cursor: pointer;
          h3{
            font-size: $topbar-font-size;
            margin: 0;
            color: $topbar-text-color-normal;
          }
        }
        .header-item{
          margin-right:1.5rem;
          text-decoration: none;
          h3{
            font-size: $topbar-font-size;
            color: $topbar-text-color-normal;
            margin: 0;
          }
          &.active{
            h3{
              color:#ffaa2f;
            }
          }
        }
      }
    }
    &.promobar {
      background-repeat: no-repeat;
      height: 37px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .loading{
        position: relative;
        height: inherit;
        @include loading();
        &::before,
        &::after {
          height: 100%;
        }
        &::before{
          background:#eee;
        }
      }
      .grid-container{
        .grid-half-item{
          padding: 0rem;
        }
        .inner {
          padding: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .promo-con{
            width:33.3%;
            text-align: center;
          }
          .promo-desc1 h3,
          .promo-desc2 h3,
          .count-down h3 {
            font-size: 1.5rem;
            margin-bottom: 0;
          }
          .promo-desc1 h3 {
            font-size: 1rem;
          }
          .promo-desc1 {
            text-align: left;
          }
          .count-down {
            min-width: 200px;
            text-align: right;
          }
        }
      }
    }
    &.main-gallery{
      .inner{
        margin-bottom:32.5px;
        height:290px;
        .gallery{
          height:100%;
          position: relative;
          &::before, &::after{
            height: 100%;
          }
        }
      }
    }
    &.fx2-upgrade{
      border-bottom: 1px solid rgb(68,68,68);
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      padding: $container-padding;
      padding-bottom: 1.5px;
      h3 {
        font-size: 1.1rem;
        font-weight: 700;
        font-family: 'Noto Sans', 'PingFang TC';
        letter-spacing: 0.27px;
        color: rgb(208, 208, 208);
        padding: 0;
        margin: 0;
      }
      .notes {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        height: 30px;
        span{
          color: $warm-grey;
          font-size: 0.786em;
          font-family: 'Noto Sans', 'PingFang TC';
          letter-spacing: 0.2px;
          line-height: 15px;
        }
      }
    }
    &.product-card{
      .grid-half-item {
        padding-bottom: 0;
        .inner {
          padding-top: 0;
          padding-bottom: 1.5rem;
        }
      }
    }
    &.feature {
      .inner {
        padding-top: 1.5rem;
        .column-content {
          &.feature-list-grid {
            > ul {
              list-style-type: none;
              font-size: 0;
              text-align: center;
              margin-left: 0;
              &.fxpack-feature {
                width: 949px;
              }
            }
            .grid-one-third-column {
              width: 31%;
              display: inline-block;
              vertical-align: top;
              .option-title {
                text-align: left;
                min-height: 80px;
                padding-left: 1.1rem;
                span {
                  font-size: 1.08rem;
                  &.option {
                    text-transform: uppercase;
                  }
                }
                &.exppack{
                  span{
                    font-size: 1.75rem;
                    &.subtitle {
                      font-size: 1rem;
                    }
                  }
                }
              }
              ul {
                margin-left: 2.3rem;
                li {
                  font-size: 1rem;
                  text-align: left;
                }
              }
              &.mid {
                margin-left: 1%;
                margin-right: 1%;
              }
              &.right {
                float: none;
              }
            }
            > ul {
              &.fxpack-feature {
                .grid-one-third-column {
                  width: 23%;
                }
              }
            }
            .grid-half-column {
              width: 49%;
              display: inline-block;
              vertical-align: top;
              .option-title {
                text-align: left;
                min-height: 80px;
                span {
                  font-size: 1.08rem;
                }
                &.pro{
                  .option{
                    font-size: 1.75rem;
                  }
                }
                &.std {
                  .option {
                    font-size: 2.2rem;
                  }
                }
              }
              ul {
                margin-left: 2.3rem;
                li {
                  font-size: 1rem;
                  text-align: left;
                }
              }
              &.right{
                float:none;
              }
              &.left{
                margin-right:1%;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/app-mon-fx2.vue